module.exports = __webpack_public_path__ + "Didot-Bold.woff?c5bdeb74785d703994268addb8f066d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/didot/Didot-Bold.woff
// module id = 313
// module chunks = 0